const m = require('air-vue-model')()
m.url = 'equipment_configs'
m.name = 'equipmentConfig'
m.setPagination({
    page_size: 'all'
})

module.exports = m